export default __webpack_public_path__ + "static/rhoimpact_logo-horizontal_color-3e0580ca74c279f07f11bdc8a309cc88.png";